<template>
  <el-dropdown size="small"
               class="d2-mr">
    <span class="btn-text">{{info.nickName ? `你好 ${info.nickName}` : '未登录'}}</span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off"
                 class="d2-mr-5" />
        注销
      </el-dropdown-item>
      <!-- <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off"
                 class="d2-mr-5" />
        修改密码
      </el-dropdown-item> -->
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      timer: null
      // auth: {
      //   unread: false
      // },
    }
  },
  computed: {
    ...mapState('d2admin/user', [
      'info'
    ])
  },
  mounted() {
    this._validationAuth()
    this.getMessageUnread()
    this.timer = setInterval(this.getMessageUnread, 1000 * 60 * 5)
  },
  methods: {
    ...mapActions('d2admin/account', [
      'logout'
    ]),
    /**
    * 权限检测
    */
    _validationAuth() {
      // this.auth.cache = this.$has('/index/help/cache')
      // this.auth.optimize = this.$has('/index/help/optimize')
      // this.auth.unread = this.$has('/system/message/unread')
    },
    /**
     * 获取未读消息数
     */
    getMessageUnread() {
      // if (!this.auth.unread) {
      //   return
      // }

      // getMessageUserUnread(null)
      //   .then(res => {
      //     if (res.data['total'] > this.unreadMessage) {
      //       const h = this.$createElement
      //       this.$notify.info({
      //         title: '消息提示',
      //         message: h('p', { style: 'cursor: pointer' }, '您有新的消息，请注意查收。'),
      //         position: 'bottom-right',
      //         onClick: () => { this.handleMessage() }
      //       })
      //     }

      //     this.$store.commit('careyshop/user/setMessage', res.data['total'])
      //   })
    },
    /**
     * @description 登出
     */
    logOff() {
      this.logout({
        confirm: true
      })
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
